import { Link } from "react-router-dom";
import { ArrowLeft, Cookie, Info, Settings } from "lucide-react";
import { Button } from "@/components/ui/button";

const Cookies = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <Link to="/">
          <Button variant="ghost" className="mb-8 group">
            <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
            Zurück zur Startseite
          </Button>
        </Link>

        <article className="prose prose-lg max-w-none">
          <h1 className="font-serif text-4xl md:text-5xl font-bold text-foreground mb-8">
            Cookie-Richtlinie
          </h1>

          <div className="bg-card p-8 rounded-2xl shadow-soft border border-border mb-8">
            <div className="flex items-center gap-4">
              <div className="w-16 h-16 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Cookie className="w-8 h-8 text-primary" />
              </div>
              <div>
                <h2 className="font-serif text-2xl font-bold text-foreground mb-1">
                  Informationen über Cookies auf unserer Website
                </h2>
                <p className="text-muted-foreground">
                  Wir verwenden nur technisch notwendige Cookies für den Betrieb der Website.
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-8 text-foreground/80">
            <section>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Info className="w-5 h-5 text-primary" />
                </div>
                <h2 className="font-serif text-2xl font-bold text-foreground">
                  Was sind Cookies?
                </h2>
              </div>
              <p className="mb-4">
                Cookies sind kleine Textdateien, die von Webseiten verwendet werden, um die Nutzererfahrung 
                effizienter zu gestalten. Cookies werden auf Ihrem Computer oder mobilen Endgerät gespeichert, 
                wenn Sie eine Website besuchen.
              </p>
              <p className="mb-4">
                Laut Gesetz können wir Cookies auf Ihrem Gerät speichern, wenn diese für den Betrieb dieser 
                Seite unbedingt notwendig sind. Für alle anderen Cookie-Typen benötigen wir Ihre Erlaubnis.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-foreground mb-4">
                Welche Cookies verwenden wir?
              </h2>
              
              <div className="space-y-6">
                <div className="bg-card p-6 rounded-xl border border-border">
                  <h3 className="font-semibold text-foreground text-lg mb-3 flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-primary"></span>
                    Technisch notwendige Cookies
                  </h3>
                  <p className="text-muted-foreground mb-4">
                    Diese Cookies sind für die grundlegende Funktionalität der Website erforderlich und können 
                    nicht deaktiviert werden.
                  </p>
                  
                  <div className="space-y-4">
                    <div className="bg-muted/30 p-4 rounded-lg">
                      <div className="font-semibold text-foreground mb-2">cookie_consent</div>
                      <div className="grid grid-cols-2 gap-4 text-sm">
                        <div>
                          <div className="text-muted-foreground mb-1">Zweck:</div>
                          <div className="text-foreground">Speichert Ihre Cookie-Einstellungen</div>
                        </div>
                        <div>
                          <div className="text-muted-foreground mb-1">Laufzeit:</div>
                          <div className="text-foreground">1 Jahr</div>
                        </div>
                        <div>
                          <div className="text-muted-foreground mb-1">Typ:</div>
                          <div className="text-foreground">Notwendig</div>
                        </div>
                        <div>
                          <div className="text-muted-foreground mb-1">Anbieter:</div>
                          <div className="text-foreground">Diese Website</div>
                        </div>
                      </div>
                    </div>

                    <div className="bg-muted/30 p-4 rounded-lg">
                      <div className="font-semibold text-foreground mb-2">session_id</div>
                      <div className="grid grid-cols-2 gap-4 text-sm">
                        <div>
                          <div className="text-muted-foreground mb-1">Zweck:</div>
                          <div className="text-foreground">Aufrechterhaltung der Session während Ihres Besuchs</div>
                        </div>
                        <div>
                          <div className="text-muted-foreground mb-1">Laufzeit:</div>
                          <div className="text-foreground">Session (beim Schließen des Browsers)</div>
                        </div>
                        <div>
                          <div className="text-muted-foreground mb-1">Typ:</div>
                          <div className="text-foreground">Notwendig</div>
                        </div>
                        <div>
                          <div className="text-muted-foreground mb-1">Anbieter:</div>
                          <div className="text-foreground">Diese Website</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-green-50 dark:bg-green-950/20 border-2 border-green-200 dark:border-green-800 p-6 rounded-xl">
                  <div className="flex items-start gap-3">
                    <Info className="w-6 h-6 text-green-600 dark:text-green-400 flex-shrink-0 mt-1" />
                    <div>
                      <h3 className="font-semibold text-foreground mb-2">Keine Tracking- oder Marketing-Cookies</h3>
                      <p className="text-sm text-foreground/80">
                        Wir verwenden bewusst keine Tracking-Cookies, Analyse-Tools (wie Google Analytics) oder 
                        Marketing-Cookies. Ihre Privatsphäre ist uns wichtig, und wir sammeln keine Daten über 
                        Ihr Surfverhalten.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-foreground mb-4">
                Drittanbieter-Cookies
              </h2>
              
              <h3 className="font-semibold text-foreground text-lg mb-3">Payhip (Zahlungsabwicklung)</h3>
              <p className="mb-4">
                Beim Kauf über Payhip werden Sie auf die Plattform von Payhip weitergeleitet. Payhip kann 
                eigene Cookies setzen, um die Kaufabwicklung zu ermöglichen. Diese unterliegen der 
                Datenschutzerklärung von Payhip.
              </p>
              <p className="mb-4">
                Weitere Informationen:{" "}
                <a 
                  href="https://payhip.com/privacy" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-primary hover:underline"
                >
                  Payhip Datenschutzerklärung
                </a>
              </p>
            </section>

            <section>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Settings className="w-5 h-5 text-primary" />
                </div>
                <h2 className="font-serif text-2xl font-bold text-foreground">
                  Cookies verwalten
                </h2>
              </div>
              
              <h3 className="font-semibold text-foreground text-lg mb-3">Browser-Einstellungen</h3>
              <p className="mb-4">
                Sie können Cookies in Ihren Browser-Einstellungen jederzeit löschen oder blockieren. Beachten 
                Sie jedoch, dass die Website ohne technisch notwendige Cookies möglicherweise nicht 
                ordnungsgemäß funktioniert.
              </p>
              
              <h3 className="font-semibold text-foreground text-lg mb-3 mt-6">
                Anleitungen für verschiedene Browser:
              </h3>
              <ul className="list-disc pl-6 space-y-2 mb-4">
                <li>
                  <a 
                    href="https://support.google.com/chrome/answer/95647" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-primary hover:underline"
                  >
                    Google Chrome
                  </a>
                </li>
                <li>
                  <a 
                    href="https://support.mozilla.org/de/kb/cookies-erlauben-und-ablehnen" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-primary hover:underline"
                  >
                    Mozilla Firefox
                  </a>
                </li>
                <li>
                  <a 
                    href="https://support.apple.com/de-de/guide/safari/sfri11471/mac" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-primary hover:underline"
                  >
                    Safari
                  </a>
                </li>
                <li>
                  <a 
                    href="https://support.microsoft.com/de-de/microsoft-edge/cookies-in-microsoft-edge-l%C3%B6schen-63947406-40ac-c3b8-57b9-2a946a29ae09" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-primary hover:underline"
                  >
                    Microsoft Edge
                  </a>
                </li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-foreground mb-4">
                Kontakt
              </h2>
              <p className="mb-4">
                Wenn Sie Fragen zu unserer Cookie-Richtlinie haben, kontaktieren Sie uns bitte:
              </p>
              <div className="bg-muted/30 p-4 rounded-lg">
                <p>
                  Osman Baltaci<br />
                  Durlachstr. 11<br />
                  44339 Dortmund<br />
                  E-Mail: osmanbaltaci@hotmail.com
                </p>
              </div>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-foreground mb-4">
                Änderungen dieser Cookie-Richtlinie
              </h2>
              <p>
                Wir können diese Cookie-Richtlinie von Zeit zu Zeit aktualisieren. Wir empfehlen Ihnen, diese 
                Seite regelmäßig zu besuchen, um über Änderungen informiert zu bleiben.
              </p>
              <p className="mt-4 text-sm text-muted-foreground">
                Letzte Aktualisierung: November 2025
              </p>
            </section>
          </div>
        </article>
      </div>
    </div>
  );
};

export default Cookies;
